export default __webpack_public_path__ + "static/media/benefit2.cb82e556.svg";